class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // Metal filter clear button
    const clearMetalButton = document.querySelector('.clear-metal-filter');
    clearMetalButton?.addEventListener('click', function () {
      const metalCheckboxes = document.querySelectorAll('input[name="filter.p.m.custom.filter_metal"]');

      metalCheckboxes.forEach(cb => {
        if (cb.checked) cb.checked = false;
      });

      const form = clearMetalButton.closest('form');
      if (form) form.submit();
    });

    
  }

  attachClearMetalHandler() {
    const clearMetalButton = document.querySelector('.clear-metal-filter');
    if (!clearMetalButton) return;

    clearMetalButton.addEventListener('click', (e) => {
      const metalCheckboxes = document.querySelectorAll('input[name="filter.p.m.custom.filter_metal"]');
      metalCheckboxes.forEach(cb => cb.checked = false);

      const form = clearMetalButton.closest('form');
      if (form) form.dispatchEvent(new Event('input', { bubbles: true })); // тригеримо форму
    });
  }


  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML;
    if ( ! count ) return false;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    
    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
    // window?.initCaratSlider();

    FacetFiltersForm.prototype.attachClearMetalHandler.call(this);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
        // section: document.getElementById('AjaxinateLoop').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const form = event.target.closest('form');
    if (!form) return; // Безпечний вихід, якщо не в формі

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(form);
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = form.id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((f) => {
        if (!isMobile) {
          if (['FacetSortForm', 'FacetFiltersForm', 'FacetSortDrawerForm'].includes(f.id)) {
            forms.push(this.createSearchParams(f));
          }
        } else if (f.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(f));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

// CaratRange з рухомим мін та мак
// перевірка щоб не було однакових данних
// перевірка щоб значення першоно інпута не було більший значення другого і наоборот
class CaratRange extends HTMLElement {
  constructor() {
    super();

    this.manualMinInput = this.querySelector('.manual-input--min');
    this.manualMaxInput = this.querySelector('.manual-input--max');
    this.rangeInputs = this.querySelectorAll('input.range');

    const availableCarats = Array.from(document.querySelectorAll('input[name="filter.p.m.custom.carat"]:not(:disabled)'))
      .map(cb => parseFloat(cb.value))
      .filter((v, i, arr) => !isNaN(v) && arr.indexOf(v) === i);

    if (availableCarats.length > 0 && this.rangeInputs.length === 2) {
      const minCarat = Math.min(...availableCarats);
      const maxCarat = Math.max(...availableCarats);

      this.initialMin = minCarat;
      this.initialMax = maxCarat;

      this.rangeInputs[0].min = minCarat;
      this.rangeInputs[0].max = maxCarat;
      this.rangeInputs[0].value = minCarat;

      this.rangeInputs[1].min = minCarat;
      this.rangeInputs[1].max = maxCarat;
      this.rangeInputs[1].value = maxCarat;

      const checkedCarats = Array.from(document.querySelectorAll('input[name="filter.p.m.custom.carat"]:checked:not(:disabled)'))
        .map(cb => parseFloat(cb.value))
        .filter(v => !isNaN(v));

      if (checkedCarats.length > 0) {
        const selectedMin = Math.min(...checkedCarats);
        const selectedMax = Math.max(...checkedCarats);

        this.rangeInputs[0].value = selectedMin;
        this.rangeInputs[1].value = selectedMax;
      }

      this.updateManualInputs();
    } else {
      this.initialMin = this.rangeInputs[0] ? parseFloat(this.rangeInputs[0].min) || 0 : 0;
      this.initialMax = this.rangeInputs[1] ? parseFloat(this.rangeInputs[1].max) || 100 : 100;
    }

    this.setMinAndMaxValues();

    this.rangeInputs.forEach(input => {
      input.addEventListener('change', this.onRangeChange.bind(this));
      input.addEventListener('input', this.updateManualInputs.bind(this));
    });

    if (this.manualMinInput) {
      this.manualMinInput.addEventListener('change', () => this.onManualInputChange('min'));
    }

    if (this.manualMaxInput) {
      this.manualMaxInput.addEventListener('change', () => this.onManualInputChange('max'));
    }

    this.querySelectorAll('.carat-manual-inputs__button').forEach(button => {
      button.addEventListener('click', () => {
        const isMin = button.closest('label').querySelector('input').classList.contains('manual-input--min');
        const type = isMin ? 'min' : 'max';
        const input = isMin ? this.manualMinInput : this.manualMaxInput;
        const direction = button.dataset.direction;
        const step = 0.05;

        let value = parseFloat(input.value) || 0;
        value = direction === 'up' ? value + step : value - step;
        value = Math.max(this.initialMin, Math.min(this.initialMax, value));

        input.value = value.toFixed(2);
        this.onManualInputChange(type);
      });
    });
  }

  setMinAndMaxValues() {
    if (this.rangeInputs.length !== 2) return;
    this.rangeInputs[0].setAttribute('min', this.initialMin);
    this.rangeInputs[0].setAttribute('max', this.initialMax);
    this.rangeInputs[1].setAttribute('min', this.initialMin);
    this.rangeInputs[1].setAttribute('max', this.initialMax);
  }

  getRange() {
    let minVal = parseFloat(this.rangeInputs[0].value);
    let maxVal = parseFloat(this.rangeInputs[1].value);
    if (minVal > maxVal) [minVal, maxVal] = [maxVal, minVal];
    return { min: minVal, max: maxVal };
  }

  updateManualInputs() {
    const { min, max } = this.getRange();
    if (this.manualMinInput) this.manualMinInput.value = min;
    if (this.manualMaxInput) this.manualMaxInput.value = max;
  }

  onManualInputChange(type) {
    if (this.rangeInputs.length !== 2) return;

    let min = parseFloat(this.manualMinInput.value);
    let max = parseFloat(this.manualMaxInput.value);
    const step = parseFloat(this.rangeInputs[0].step) || 0.01;

    if (isNaN(min)) min = this.initialMin;
    if (isNaN(max)) max = this.initialMax;

    if (min > max) {
      if (type === 'min') min = max - step;
      else max = min + step;
    }

    min = Math.max(min, this.initialMin);
    max = Math.min(max, this.initialMax);

    this.rangeInputs[0].value = min;
    this.rangeInputs[1].value = max;

    this.updateManualInputs();
    this.applyFilter();
  }

  onRangeChange() {
    const { min, max } = this.getRange();
    this.rangeInputs[0].value = min;
    this.rangeInputs[1].value = max;
    this.updateManualInputs();
    this.applyFilter();
  }

  applyFilter() {
    const { min, max } = this.getRange();

    const checkboxes = document.querySelectorAll('input[name="filter.p.m.custom.carat"]:not(:disabled)');
    if (!checkboxes.length) return;

    // 1. Зберігаємо попередній стан
    const previousSelected = Array.from(checkboxes)
      .filter(box => box.checked)
      .map(box => box.value)
      .sort();

    // 2. Оновлюємо галочки відповідно до діапазону
    checkboxes.forEach(box => {
      const val = parseFloat(box.value);
      box.checked = val >= min && val <= max;
    });

    // 3. Отримуємо новий стан
    const newSelected = Array.from(checkboxes)
      .filter(box => box.checked)
      .map(box => box.value)
      .sort();

    // 4. Порівнюємо масиви
    const hasChanged = previousSelected.length !== newSelected.length ||
      previousSelected.some((val, i) => val !== newSelected[i]);

    if (!hasChanged) {
      console.log('No filter change, skipping form update');
      return;
    }

    // 5. Оновлюємо URL
    const url = new URL(window.location);
    url.searchParams.delete('filter.p.m.custom.carat');
    url.searchParams.delete('min');
    url.searchParams.delete('max');

    newSelected.forEach(carat => url.searchParams.append('filter.p.m.custom.carat', carat));
    url.searchParams.append('min', min);
    url.searchParams.append('max', max);
    window.history.replaceState(null, '', url.toString());

    // 6. Сабмітимо форму
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (form) {
      const event = new Event('input', { bubbles: true });
      form.querySelector('form').dispatchEvent(event);
    }
  }

}

customElements.define('carat-range', CaratRange);




class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
